(function ($, undefined) {

	'use strict';
	var submitting = false;
	var form;
	var header;
	var accountForm;
	var accountFormSubmit;

	var changeEmail;
	var changePassword;

	var profileInput;

	var agencyField;
	var agencysubmit;
	var agencyAccept;
	var agencyRefuse;
	var agencyCancel;

	var intLang;

	var projectList;
	var projectForm;
	var projectSubmit;

	var resultsCtn;
	var emailLinkQuery = null;

	var nav;
	var selectedPersonId = null;
	var selectedPersonEmail = null;
    
	var profileStudio = null;
	var profileSourceConnect = null;
    
    var preventDefault = function(e) {
        e.preventDefault();
    };

	var changeProfilePic = function () {
		var t = $(this);
		var files = t[0].files;
		var size = files[0].size;

		if (files !== undefined) {
			if (size <= 1048576) { // 1MB
				$('.account-pic-img-ctn').addClass('is-processing');

				for (var i = 0; i < files.length; i++) {

					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1].toLowerCase();

					if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
						var data = new FormData();
						data.append('pic', files[i]);
						data.append('center', true);
						data.append('smartCrop', false);
						data.append('ajax', true);

						$.ajax({
							url: '/action/uploadPersonPic',
							cache: false,
							contentType: false,
							processData: false,
							method: 'POST',
							data: data,
							success: function (response) {
								var id = response;
								$('.account-pic-img-ctn').removeClass('is-processing');

								$('.account-pic-img-ctn').show();
								$('.account-pic-img').attr('src', '/static/uploaded/Profile/' + (id).replace(/(\r\n\t|\n|\r\t)/gm, "") + '-main.jpg');

								form.resetUpload(t);

								var successMessage = $('.form-popup-message.profile-pic-success');
								successMessage.addClass('show');

								setTimeout(function () {
									successMessage.removeClass('show');
								}, 5000);
							}
						});
					} else {
						$('.account-pic').removeClass('is-processing');
						var errorMessage = $('.form-popup-message.profile-pic-error');

						errorMessage.addClass('show');

						setTimeout(function () {
							errorMessage.removeClass('show');
						}, 5000);
					}
				}
			} else {
				form.showErrorPopupAnimation('profile-pic-size-message-error');
			}
		}
	};

	var formatStringArray = function (list, form) {
		var data = '';

		$(list + ' .account-option-item:not(.clone)', form).each(function () {
			var t = $(this);

			if (data.length !== 0) {
				data += ',';
			}

			data += t.attr('data-value');

			// adding main lang id
			if (data.indexOf(t.attr('data-main')) === -1 && t.attr('data-main') !== undefined) {
				data += ',' + t.attr('data-main');
			}
		});

		return data;
	};

	var submitForm = function () {
		var $curCtn = $('.tab-ctn.selected');

		$('.form-input[name="agence"]', accountForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-title"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-categories"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-role"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-director"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-producer"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();

		$('.account-form-tab').removeClass('has-error');
		$curCtn.removeClass('has-error');
		form.validateForm($curCtn);

		if ($curCtn.hasClass('has-error')) {
			form.showErrorPopup();

			$('.form-input-big-ctn.error').each(function () {
				var tabId = $(this).closest('.tab-ctn').attr('data-tab');
				$('.account-form-tab[data-tab="' + tabId + '"]').addClass('has-error');
			});
		} else {
			var accountType = accountForm.attr('data-type');

			var data = {
				"ajax": true
			};

			$curCtn.find('.form-submit-input').each(function () {
				if (this.tagName === 'DIV') {
					data[this.getAttribute('name')] = this.getAttribute('data-value');
				} else if (this.type === 'radio' || this.type === 'checkbox') {
					data[this.name] = (this.checked)  ? 'true' : 'false';
				} else {
					data[this.name] = this.value;
				}
			});

			if (accountType === '0') {
				var type = formatStringArray('.account-type-list', accountForm);
				var regions = formatStringArray('.account-region-list', accountForm);
				var associations = formatStringArray('.account-associations-list', accountForm);
				var languagesInterpretation = formatStringArray('.account-int-lang-list', accountForm);
				var voiceAge = formatStringArray('.account-voice-age-list', accountForm);
				var interpretationType = formatStringArray('.account-interpretation-type-list', accountForm);
				var timbre = formatStringArray('.account-timbre-list', accountForm);
				var typeVideo = formatStringArray('.account-type-video-list', accountForm);
				var formatVideo = formatStringArray('.account-format-video-list', accountForm);
				var interpretationTypeVideo = formatStringArray('.account-interpretation-type-video-list', accountForm);

				data["gender"] = $('.form-input[name="gender"]').attr('data-value');
				data["field3"] = $('.form-input[name="field3"]').val();
				if ($curCtn.find('.account-type-list')[0]) {
					data.field4 = type;
				}
				if ($curCtn.find('.account-region-list')[0]) {
					data.field12 = regions;
				}
				if ($curCtn.find('.account-associations-list')[0]) {
					data.field13 = associations;
				}
				if ($curCtn.find('.account-int-lang-list')[0]) {
					data.field18 = languagesInterpretation;
				}
				if ($curCtn.find('.account-voice-age-list')[0]) {
					data.field19 = voiceAge;
				}
				if ($curCtn.find('.account-interpretation-type-list')[0]) {
					data.field20 = interpretationType;
				}
				if ($curCtn.find('.account-timbre-list')[0]) {
					data.field29 = timbre;
				}
				if ($curCtn.find('.account-type-video-list')[0]) {
					data.field32 = typeVideo;
				}
				if ($curCtn.find('.account-format-video-list')[0]) {
					data.field33 = formatVideo;
				}
				if ($curCtn.find('.account-interpretation-type-video-list')[0]) {
					data.field34 = interpretationTypeVideo;
				}
			} else if (accountType === '1') {

			} else if (accountType === '2') {
				var associationsAgency = formatStringArray('.account-agency-associations-list', accountForm);

				if ($curCtn.find('.account-agency-associations-list')[0]) {
					data.field13 = associationsAgency;
				}
			}

			if (accountType === '0' || accountType === '2') {
				if ($curCtn.find('.form-social-media-input')[0]) {
					var social = {
						"facebook": $('.form-social-media-input[name="facebook"]').val(),
						"twitter": $('.form-social-media-input[name="twitter"]').val(),
						"linkedin": $('.form-social-media-input[name="linkedin"]').val(),
						"youtube": $('.form-social-media-input[name="youtube"]').val(),
						"vimeo": $('.form-social-media-input[name="vimeo"]').val(),
						"website": $('.form-social-media-input[name="website"]').val()
					};
					data["field21"] = JSON.stringify(social);
				}
				try { // Biography
					data["field26"] = tinyMCE.get('field26', $curCtn).getContent();
				} catch (exception) {
					data["field26"] = $('.field26', $curCtn).val();
				}
				try { // Biography english
					data["field31"] = tinyMCE.get('field31', $curCtn).getContent();
				} catch (exception) {
					data["field31"] = $('.field31', $curCtn).val();
				}
			}

			if (data.hasOwnProperty('email')) {
				delete data.email;
			}

			$.ajax({
				url: '/action/updatePerson',
				cache: false,
				data: data,
				success: function (response) {
//					console.log('updatePerson : ', response);

					form.showSuccessPopup();
				}
			});
		}

		return false;
	};

	var submitAgencyRequest = function () {
		var data = {};
		var email;

		if (selectedPersonId !== null) {
			data.personId = selectedPersonId;
		}

		selectedPersonEmail !== null ? email = selectedPersonEmail : email = agencyField.val();

		if (selectedPersonId === null) {
			data.email = email;
		}
		
		$('.account-agency-pending').slideUp(200);
		
		if (selectedPersonId != null) {
			$.ajax({
				url: '/action/vcManageInvitations',
				cache: false,
				data: data,
				success: function (response) {
	//				console.log('agency : ' + response);
					var nameVal = agencyField.val();

					agencyField.val('').closest('.form-input-big-ctn').removeClass('error success');

					if (response === 'fail') {
						form.showErrorPopup();
					} else if (response === 'fail wrong type account') {
						form.showErrorPopupAnimation('agency-link-error');
					} else if (response === 'already-in-process') {
						form.showErrorPopupAnimation('agency-already-in-progress');
					} else if (response === 'already-linked') {
						form.showErrorPopupAnimation('agency-already-linked');
					} else {
						form.showErrorPopupAnimation('agency-link-success');

						$('.account-agency-pending').slideDown(200);
						var clone = $('.account-link-invitation-sent.clone').clone();
						var clonePopup = $('.account-form-link-artist-agency-cancel-popup.clone').clone();

						clonePopup.find('.action-form-item').html(email);
						clonePopup.attr('data-id', 'invitation-' + response.split('success-')[1]);
						clonePopup.find('.account-form-link-artist-agency-cancel').attr('data-item-id', response.split('success-')[1]);
						clone.find('.account-link-invitation-sent-email').html(email);
						clone.find('.account-link-invitation-sent-action .btn').attr('data-id', 'invitation-' + response.split('success-')[1]);
						if (nameVal !== email) {
							clone.find('.account-link-invitation-sent-name').html(nameVal);
						}
						clone.attr('data-id', response.split('success-')[1]);
						$('.account-form-link-invitation-sent-list-inner').append(clone);
						$('.account-form-link-invitation-sent-list-inner').append(clonePopup);
						clone.removeClass('hide clone');
						clonePopup.removeClass('clone');
						$('.account-form-error-message.invitation-sent').slideUp();
					}
				}
			});
		}
		else {
			form.showErrorPopup();
		}
	};

	var acceptInvite = function () {
		var t = $(this);
		var id = t.attr('data-id');

		$('.account-link-forms.accept[data-id="' + id + '"]').submit();
	};

	var refuseInvite = function () {
		var t = $(this);
		var id = t.attr('data-id');

		$('.account-link-forms.refuse[data-id="' + id + '"]').submit();
	};

	var cancelLink = function (e) {
        var t = $(e.currentTarget);
		var itemId = t.attr('data-item-id');
		var item = $('.account-link-invitation-sent[data-id="' + itemId + '"]');

		$.ajax({
			url: '/action/vcManageInvitations',
			cache: false,
			data: {
				id: itemId,
				cancel: true
			},
			success: function (response) {
//				console.log('cancel invite : ' + response);

				if (response === 'success') {
					item.slideUp(200, function () {
						item.remove();

						$('.popup').removeClass('open');
						$('body').removeClass('popup-show');
						header.addScroll();

						if ($('.account-link-invitation-sent').length === 0) {
							$('.account-form-error-message.invitation-sent').slideDown(200);
						}
					});

					form.showErrorPopupAnimation('cancel-invitation-success');
				} else {
					form.showErrorPopupAnimation('cancel-invitation-error');
				}
			}
		});
	};

	var breakLink = function () {
		var itemId = $(this).attr('data-item-id');
		var item = $('.account-form-link-artist-agency-item[data-id="' + itemId + '"]');

		$.ajax({
			url: '/action/vcManageInvitations',
			cache: false,
			data: {
				personId: itemId,
				break: true
			},
			success: function (response) {
//				console.log('break link : ' + response);

				if (response === 'success') {
					item.slideUp(200, function () {
						item.remove();

						$('.popup').removeClass('open');
						$('body').removeClass('popup-show');
						header.addScroll();

						if ($('.account-form-link-artist-agency-item').length === 0) {
							$('.account-form-error-message.agency').slideDown(200);
						}
					});

					form.showErrorPopupAnimation('break-invitation-success');
				} else {
					form.showErrorPopupAnimation('break-invitation-error');
				}
			}
		});
	};

	var multipleSelectAdd = function () {
		var t = $(this);
		var ctn = t.closest('.account-multiple-select-ctn');
		var list = $('.account-multiple-select', ctn);
		var newElt = $('.account-option-item.clone', list).clone().removeClass('clone');
		var value = t.attr('data-value');
		var mainLangId = t.attr('data-main');
		var title = t.text();

		if (value !== '') {
			t.hide();
			$('.account-option-item-value', newElt).html(title);
			newElt.attr('data-value', value);

			if (mainLangId !== undefined) {
				newElt.attr('data-main', mainLangId);
			}
			list.append(newElt);
			ctn.find('.form-select.form-input.select-value').html('');
		} else if (value === '' && ctn.find('.form-select-ctn').hasClass('empty-remove-tags')) {
			list.find('.account-option-item:not(.clone) .account-option-item-del').each(function() {
				$(this).trigger('click');
			});
		}
	};

	var delAccountItem = function (e) {
		var t = $(e.currentTarget);
		var item = t.closest('.account-option-item');
		var rel = item.attr('data-rel');
		var value = item.attr('data-value');

		$('.form-select[name="' + rel + '"]').closest('.form-input-ctn').find('.select-option[data-value="' + value + '"]').show();

		t.closest('.account-option-item').remove();
	};

	var submitProject = function () {
		$('.form-input, .form-item-upload-input', projectForm).addClass('required').closest('.form-input-big-ctn').addClass('required');

		form.validateForm(projectForm);

		if (!projectForm.hasClass('has-error')) {
			var title = $('.form-input[name="project-title"]', projectForm).val();
			var cat = $('.form-input[name="project-categories"]', projectForm).val();
			var role = $('.form-input[name="project-role"]', projectForm).val();
			var director = $('.form-input[name="project-director"]', projectForm).val();
			var producer = $('.form-input[name="project-producer"]', projectForm).val();

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					field1: 'project',
					field2: $('.account-form').attr('data-person-id'),
					field3: title,
					field4: cat,
					field5: role,
					field6: director,
					field7: producer,
					ajax: true
				},
				method: 'POST',
				success: function (response) {
					var newId = response.substring('success-'.length);
//					console.log('project : ' + response);

					var newElt = $('.account-projects-item.clone').clone().removeClass('clone');
					$('.account-projects-item-title', newElt).html(title);
					$('.account-projects-item-info.cat span', newElt).html(cat);
					$('.account-projects-item-info.role span', newElt).html(role);
					$('.account-projects-item-info.director span', newElt).html(director);
					$('.account-projects-item-info.producer span', newElt).html(producer);
					$('.account-projects-item-del', newElt).attr('data-id', 'project-' + newId);
					newElt.attr('data-id', newId);

					var newPopup = $('.popup.action-form.clone').clone().removeClass('clone');
					newPopup.attr('data-id', 'project-' + newId);
					$('.action-form-item', newPopup).html(title);
					$('.js-account-projects-item-del', newPopup).attr('data-item-id', newId);

					projectList.append(newElt);
					projectList.append(newPopup);

					projectForm.find('.form-input').val('').removeClass('has-char success');
					projectForm.find('.form-input-big-ctn').removeClass('has-char success');

					if ($('.account-projects-item:not(.clone)').length >= 2) {
						$('.account-project-form').addClass('disabled');
					}
				}
			});
		}

		$('.form-input, .form-item-upload-input', projectForm).removeClass('required').closest('.form-input-big-ctn').removeClass('required');
	};

	var delProject = function (e) {
		var t = $(e.currentTarget);
		var itemId = t.attr('data-item-id');
		var item = $('.account-projects-item[data-id="' + itemId + '"]');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				delete: true,
				ajax: true
			},
			method: 'POST',
			success: function (response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
//				console.log('project : ' + response + ', ' + isSuccess);

				if (isSuccess) {
					form.showErrorPopupAnimation('project-delete-success');

					item.slideUp(200, function () {
						item.remove();
					});

					$('.popup').removeClass('open');
					$('body').removeClass('popup-show');
					$('.account-project-form').removeClass('disabled');
					header.addScroll();
				} else {
					form.showErrorPopupAnimation('project-delete-error');
				}
			}
		});
	};

	var validateChangeForm = function (e) {
		if (e)
			e.preventDefault();

		var t = $(this);

		form.validateForm(t);

		if (t.hasClass('has-error') || submitting) {
			return false;
		}
		submitting = true;

		var $email = t.find('input[name="email"]');
		$.ajax("/action/validateUsername", {
			data: "username=" + encodeURIComponent($email.val()),
			cache: false,
			success: function (res) {
				if (res.indexOf("success") > -1) {
					t[0].submit();
				} else {
					form.showErrorPopup('email-error');
					t.addClass('has-error');
					$email.removeClass('success').addClass('error')
						.closest('.form-input-big-ctn').removeClass('success').addClass('error');
				}
			},
			error: function () {
				form.showErrorPopup('email-error');
				t.addClass('has-error');
				$email.removeClass('success').addClass('error')
					.closest('.form-input-big-ctn').removeClass('success').addClass('error');
				//Something went wrong with the internet or server.
			}
		});
	};

	var checkEmailChange = function (e) {
		if (this.value.trim() !== this.getAttribute('data-misc')) {
			this.form.querySelector('button').disabled = false;
		} else {
			this.form.querySelector('button').disabled = true;
		}
	};

	var cancelEmailChange = function (e) {
		ajaxBlackout(true, false);
		$.ajax("/action/manageGenData", {
			data: "?ajax=true&delete=true&id=" + this.getAttribute("data-id"),
			cache: false,
			complete: function (response) {
				window.location.href = window.location.pathname;
			}
		});
	};

	var validateChangePassword = function (e) {
		if (e) {
			e.preventDefault();
		}

		var t = $(this);

		form.validatePassword(t, true);
		if (t.hasClass('has-error') || submitting) {
			return false;
		}

		submitting = true;
		t[0].submit();
	};

	var navChangeTab = function () {
		var t = $(this);
		var tab = t.val();

		$('.tab[data-tab=' + tab +']').trigger('click');
	};

	var createArtist = function (captcha) {
        var btn = $(this);
		var $form = btn.closest('form');
		var popup = btn.closest('.popup');
		
        if (btn.hasClass('disabled')) {
            return false;
        }

		form.validateForm($form);
		if ($form.hasClass('has-error')) {
            grecaptcha.reset(btn.attr('data-widget-id'));
			return false;
		}
        btn.addClass('disabled');
        popup.addClass('is-processing');

        var data = {
            "captcha": captcha,
            "email": $('.form-input[name="email"]', $form).val(),
            "password": $('input[name="password"]', $form).val(),
            "firstName": $('.form-input[name="firstName"]', $form).val(),
            "lastName": $('.form-input[name="lastName"]', $form).val(),
            "field1": "0",
            "field5": $('input[name="field5"]', $form).val(),
            "field16": 'change-pw',
            "returnId": true,
            "ajax": true
        };

        $.ajax({
            url: '/action/createAccount',
            type: 'POST',
            cache: false,
            data: data,
            success: function (response) {
                if (response.indexOf('success') !== -1) {
                    var id = response.split('-')[1];
                    var artistsIds = btn.attr('data-artistsids').length ? btn.attr('data-artistsids') + ',' + id : id;

                    $.ajax({
                        url: '/action/updatePerson',
                        cache: false,
                        data: {
                            "field5": artistsIds,
                            "ajax": true
                        },
                        success: function (response) {
                            window.location.href = $('input[name="forward"]', $form).val();
                        }
                    });
                } else if (response.indexOf('fail') !== -1) {
                    form.showErrorPopupAnimation('email-error');
                    popup.removeClass('is-processing');
                    btn.removeClass('disabled');
                    grecaptcha.reset(btn.attr('data-widget-id'));
                }
            }
        });
	};

	var triggerHijackUser = function () {
		var t = $(this);
		var id = t.attr('data-id');

		$('.hijack-form[data-id=' + id + ']').submit();
	};

	var filterEmailLinks = function () {
		var input = $(this);
		var searchValue = input.val().toLowerCase();
		var ctn = input.closest('.find-link-email-ctn');

		selectedPersonId = null;
		selectedPersonEmail = null;

		if (searchValue === '') {
			$('.find-link-email-choice').addClass('hide-search');
			resultsCtn.slideUp();
			return false;
		}

		$('.find-link-email-choice').each(function () {
			var t = $(this);
			var name = t.attr('data-name').toLowerCase();
			var email = t.attr('data-email').toLowerCase();
			var agencyNameAttr = t.attr('data-agency-name');
			var agencyName = agencyNameAttr != undefined  ? agencyNameAttr.toLowerCase() : "";
			var isOk = true;
			var qs = searchValue.split(" ").filter((item) => item.length > 0); 
			
			for (var i in qs) {
				var q = qs[i].toLowerCase();
				if (!(email.indexOf(q) !== -1 || name.indexOf(q) !== -1 || (agencyName.length > 0 && agencyName.indexOf(q) !== -1))) {
					isOk = false;
				}
			}

			if (isOk) {
				t.removeClass('hide-search');
			} else {
				t.addClass('hide-search');
			}
		});

		resultsCtn.find('.find-link-email-choice:not(.hide-search)').length !== 0 ? resultsCtn.slideDown() : resultsCtn.slideUp();
	};

	var checkfilterEmailInput = function (e) {
		var result = $('.find-link-email-choice:not(.hide-search)');
		var next = null;
		var prev = null;

		if ($(this).val() !== emailLinkQuery) {
			resultsCtn.find('.find-link-email-choice.selected').removeClass('selected');
			emailLinkQuery = $(this).val();
		}

		var selectedResult = resultsCtn.find('.find-link-email-choice.selected');

		if (selectedResult.next('.find-link-email-choice:not(.hide-search)').length !== 0) {
			next = selectedResult.next('.find-link-email-choice:not(.hide-search)');
		} else if (selectedResult.nextUntil('.find-link-email-choice:not(.hide-search)').last().next().length !== 0) {
			next = selectedResult.nextUntil('.find-link-email-choice:not(.hide-search)').last().next();
		}

		if (selectedResult.prev('.find-link-email-choice:not(.hide-search)').length !== 0) {
			prev = selectedResult.prev('.find-link-email-choice:not(.hide-search)');
		} else if (selectedResult.prevUntil('.find-link-email-choice:not(.hide-search)').last().prev().length !== 0) {
			prev = selectedResult.prevUntil('.find-link-email-choice:not(.hide-search)').last().prev();
		}

		if ((e.which === 40 || e.which === 38) && selectedResult.length === 0) {
			resultsCtn.find('.find-link-email-choice:not(.hide-search)').first().addClass('selected');
		} else if (e.which === 40 && next !== null) { // down
			selectedResult.removeClass('selected');
			next.addClass('selected');
			// resultsCtn.animate({scrollTop: next.offset().top});
		} else if (e.which === 38 && prev !== null) { // up
			selectedResult.removeClass('selected');
			prev.addClass('selected');
		}
	};

	var selectPerson = function () {
		var t = $(this);
		var email = t.attr('data-email');
		var id = t.attr('data-id');

		if (id.length > 0) {
			selectedPersonId = id;
		}

		if (email.length > 0) {
			selectedPersonEmail = email;
		}

		$('.filter-email-links-input').val(t.find('.person').html());
		resultsCtn.find('.find-link-email-choice.selected').removeClass('selected').addClass('hide-search');
		resultsCtn.slideUp();
	};

	var updateManagementRights = function (e) {
		var t = $(e.currentTarget);
		var item = t.closest(".artist-authorize-auditions-ctn");
		var personId = item.attr("data-id");
		var changeToArtist =  item.attr('data-demos-to-change-artist') !== '' ? item.attr('data-demos-to-change-artist').split(',') : [];
		var changeToAgency =  item.attr('data-demos-to-change-agency') !== '' ? item.attr('data-demos-to-change-agency').split(',') : [];

		var newChangeToArtist = changeToArtist.slice(0);
		var newChangeToAgency = changeToAgency.slice(0);

		var url = "/action/vcHijack";
		url += "?ajax=true";
		url += "&authorizeManagement=" + t.is(":checked");
		url += "&personId=" + personId;

		ajax(url, function () {
            // Update the existing application-demo for the reapproval status
			if (t.is(":checked")) {
				for (var h = 0; h < changeToArtist.length; h++) {
					newChangeToAgency.push(changeToArtist[h]);
					item.attr('data-demos-to-change-agency', newChangeToAgency);

					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: changeToArtist[h],
							field8: '2',
							ajax: true
						},
						success: function (response) {
							//console.log('Change to reaprove by artist : ' + response);
						}
					});
				}
				item.attr('data-demos-to-change-artist', '');
			} else {
				for (var k = 0; k < changeToAgency.length; k++) {
					newChangeToArtist.push(changeToAgency[k]);
					item.attr('data-demos-to-change-artist', newChangeToArtist);

					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: changeToAgency[k],
							field8: '1',
							ajax: true
						},
						success: function (response) {
							//console.log('Change to reaprove by agency : ' + response);
						}
					});
				}
				item.attr('data-demos-to-change-agency', '');
			}
		}, true);

	};
    
    var unclickSourceConnect = function(){
        if(!$(this).is(":checked")){
            profileSourceConnect.prop("checked", false);
        }
    };
    
    var clickStudio = function(){
        if($(this).is(":checked")){
            profileStudio.prop("checked", true);
        }
        
    };

	var init = function () {
		form = Fw.component.models().form;
		header = Fw.modules.models().header;
		accountForm = $('.account-form');
		accountFormSubmit = $('.account-form-submit');

		changeEmail = $('.account-change-email');
		changePassword = $('.account-change-password');

		profileInput = $('.form-item-upload-input[name="profile-pic"]');

		agencyField = $('.form-input[name="agence"]');
		agencysubmit = $('.account-agency-submit');
		agencyAccept = $('.account-link-invitation-action-accept');
		agencyRefuse = $('.account-link-invitation-action-refuse');
		agencyCancel = $('.account-link-invitation-sent-action-refuse');

		projectList = $('.account-projects-list');
		projectForm = $('.account-project-form');
		projectSubmit = $('.account-project-form-btn');

		resultsCtn = $('.find-link-email-choices-ctn');
        
		profileStudio = $('.profile-studio', accountForm);
		profileSourceConnect = $('.profile-source-connect', accountForm);

		nav = $('.account-nav-select');

		accountFormSubmit.click(submitForm);
		profileInput.on('change', changeProfilePic);
		$('.account-multiple-select-ctn').on('click', '.select-option', multipleSelectAdd);
		$('body').on('click', '.account-option-item-del', delAccountItem);
		agencysubmit.click(submitAgencyRequest);
		agencyAccept.click(acceptInvite);
		agencyRefuse.click(refuseInvite);
		agencyCancel.click(breakLink);
		projectSubmit.click(submitProject);
		$('body').on('click', '.account-form-link-artist-agency-cancel', cancelLink);
		$('body').on('click', '.js-account-projects-item-del', delProject);
		changeEmail.on('submit', validateChangeForm);
		changeEmail.find('.account-change-email-input').on('input', checkEmailChange);
		changePassword.on('submit', validateChangePassword);
		nav.change(navChangeTab);
		$('.account-change-email-cancel').on('click', cancelEmailChange);
		$('button[type=button].hijack-user-btn').click(triggerHijackUser);
		$('.filter-email-links-input').keyup(filterEmailLinks);
		// $('.filter-email-links-input').keydown(checkfilterEmailInput);
		$('.find-link-email-choice').click(selectPerson);
        $('body').on('change', '.authorize-audition-management', updateManagementRights);
        
//        profileStudio.on("click", unclickSourceConnect);
//        profileSourceConnect.on("click", clickStudio);

        $('.create-artist-btn').each(function(i, el) {
            $(el).closest('form').on('submit', preventDefault);
            Fw.component.models().utils.recaptcha2(el, createArtist);
        });

	};

	$(window).ready(init);

	Fw.page.export('account', {
		formatStringArray: formatStringArray
	});

})(jQuery);
